<template>
  <div class="content" style="padding: 0px; font-size: 12px">
    <div class="container pd-x-0 pd-lg-x-10 pd-xl-x-0">
      <div class="row row-xs">
        

        <div class="col-6">
            <div class="card">
              <div class="card-header">
                <h6 class="mg-b-0">Гэрэл дохио</h6>
              </div><!-- card-header -->
              <div class="card-body pd-0">
                <div class="row no-gutters">
                  <div class="col col-sm-4 col-lg">
                    <div class="crypto">
                      <div class="media">
                        <div class="media-body pd-20 d-flex align-items-end">
                  
                    <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 mg-b-0">Нийт</h6>
                    <h5 class="tx-normal tx-rubik mg-b-0 mg-l-auto lh-1">{{assets.signal.allCount}}</h5>
                  
                        </div><!-- media-body -->
                      </div><!-- media -->


                    </div><!-- crypto -->
                  </div>
                  <div class="col col-sm-4 col-lg bd-t bd-sm-t-0 bd-sm-l">
                    <div class="crypto">
                      <div class="media">
                        <div class="media-body pd-20 d-flex align-items-end">
                  
                    <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 mg-b-0">Хэвийн</h6>
                    <h5 class="tx-normal tx-rubik mg-b-0 mg-l-auto lh-1">{{assets.signal.count}}</h5>
                  
                        </div><!-- media-body -->
                      </div><!-- media -->
                    </div><!-- crypto -->
                  </div>
                  <div class="col col-sm-4 col-lg bd-t bd-sm-t-0 bd-sm-l">
                    <div class="crypto">
                      <div class="media">
                        <div class="media-body pd-20 d-flex align-items-end">
                  
                    <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 mg-b-0">Засвартай</h6>
                    <h5 class="tx-normal tx-rubik mg-b-0 mg-l-auto lh-1">{{assets.signal.allCount-assets.signal.count}}</h5>
                  
                        </div><!-- media-body -->
                      </div><!-- media -->
                    </div><!-- crypto -->
                  </div>
                </div><!-- row -->
              </div><!-- card-body -->
            </div><!-- card -->
          </div>

          <div class="col-6">
            <div class="card">
              <div class="card-header">
                <h6 class="mg-b-0">Камер</h6>
              </div><!-- card-header -->
              <div class="card-body pd-0">
                <div class="row no-gutters">
                  <div class="col col-sm-4 col-lg">
                    <div class="crypto">
                      <div class="media">
                        <div class="media-body pd-20 d-flex align-items-end">
                  
                    <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 mg-b-0">Нийт</h6>
                    <h5 class="tx-normal tx-rubik mg-b-0 mg-l-auto lh-1">{{assets.penaltyCamera.allCount}}</h5>
                  
                        </div><!-- media-body -->
                      </div><!-- media -->


                    </div><!-- crypto -->
                  </div>
                  <div class="col col-sm-4 col-lg bd-t bd-sm-t-0 bd-sm-l">
                    <div class="crypto">
                      <div class="media">
                        <div class="media-body pd-20 d-flex align-items-end">
                  
                    <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 mg-b-0">Хэвийн</h6>
                    <h5 class="tx-normal tx-rubik mg-b-0 mg-l-auto lh-1">{{assets.penaltyCamera.count}}</h5>
                  
                        </div><!-- media-body -->
                      </div><!-- media -->
                    </div><!-- crypto -->
                  </div>
                  <div class="col col-sm-4 col-lg bd-t bd-sm-t-0 bd-sm-l">
                    <div class="crypto">
                      <div class="media">
                        <div class="media-body pd-20 d-flex align-items-end">
                  
                    <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 mg-b-0">Засвартай</h6>
                    <h5 class="tx-normal tx-rubik mg-b-0 mg-l-auto lh-1">{{assets.penaltyCamera.allCount-assets.penaltyCamera.count}}</h5>
                  
                        </div><!-- media-body -->
                      </div><!-- media -->
                    </div><!-- crypto -->
                  </div>
                </div><!-- row -->
              </div><!-- card-body -->
            </div><!-- card -->
          </div>
        <div class="col-lg-4 mg-t-10">
          <div class="card">
            <div class="card-header">
              <h6 class="mg-b-0">Тээврийн хэрэгсэл</h6>
            </div>
            <div class="card-body">
              <ul class="list-group list-group-flush tx-13">
                    
                <li class="list-group-item d-flex pd-sm-0">
                  <div class="avatar d-none d-sm-block"><span class="avatar-initial rounded-circle bg-orange op-5"><i class="icon ion-md-bus"></i></span></div>
                  <div class="pd-sm-l-10">
                    <p class="tx-medium mg-b-2">4433</p>
                    <small class="tx-12 tx-color-03 mg-b-0">Тээврийн хэрэгсэл давхардсан тоогоор</small>
                  </div>
                </li>
                <li class="list-group-item d-flex pd-sm-0 mg-t-5">
                  <div class="avatar d-none d-sm-block"><span class="avatar-initial rounded-circle bg-orange op-5"><i class="icon ion-md-bus"></i></span></div>
                  <div class="pd-sm-l-10">
                    <p class="tx-medium mg-b-2">4433</p>
                    <small class="tx-12 tx-color-03 mg-b-0">Тээврийн хэрэгсэл давхардалгүй тоогоор</small>
                  </div>
                </li>
                    
              </ul>
            </div>
          </div>

          <div class="card mg-t-20">
            <div class="card-header">
              <h6 class="mg-b-0">Дугаарын хязгаарлалт зөрчсөн</h6>
            </div>
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="profile-skillset flex-fill">
                  <h4><a href="" class="link-01">1.4k</a></h4>
                  <label>Даваа</label>
                </div>
                <div class="profile-skillset flex-fill">
                  <h4><a href="" class="link-01">2.8k</a></h4>
                  <label>Мягмар</label>
                </div>
                <div class="profile-skillset flex-fill">
                  <h4><a href="" class="link-01">437</a></h4>
                  <label>Лхагва</label>
                </div>
              </div>
              <div class="d-flex align-items-center bd-t pd-t-10 mg-t-10">
                <div class="profile-skillset flex-fill">
                  <h4><a href="" class="link-01">1.4k</a></h4>
                  <label>Пүрэв</label>
                </div>
                <div class="profile-skillset flex-fill">
                  <h4><a href="" class="link-01">2.8k</a></h4>
                  <label>Баасан</label>
                </div>
              </div>
            </div>
          </div>

          <div class="card card-events mg-t-20">
            <div class="card-header">
              <h6 class="mg-b-0">Товчоодын нэвтрэлт</h6>
            </div>
            <div class="card-body">
              <ul class="list-unstyled media-list mg-b-0">
                  <!-- <li class="media">
                    <div class="media-left">
                      <p class="mg-b-0 pd-t-10">403</p>
                    </div>
                    <div class="media-body event-panel-green">
                      <h6 class="event-title">Эмээлт</h6>
                    </div>
                  </li>
                  <li class="media">
                    <div class="media-left">
                      <p class="pd-t-10">108</p>
                    </div>
                    <div class="media-body event-panel-primary">
                      <h6 class="event-title">Хоолт</h6>
                    </div>
                  </li> -->
                  <li class="media" v-for="(t,i) in tovchoods" :key="i">
                    <div class="media-left">
                      <p class="pd-t-10">{{t.count}}</p>
                    </div>
                    <div :class="`media-body event-panel-${colors[i]}`">
                      <h6 class="event-title">{{t.entranceName}}</h6>
                    </div>
                  </li>
                </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-8 mg-t-10">
          <div class="card card-crypto">
            <div class="card-header d-flex">
              <h6 class="mg-b-0">Газрын зураг</h6>
              <DatePicker class="mg-l-auto" size="mini"
                v-model="mapDate"
                type="date"
                placeholder="Өдөр сонгоно уу">
              </DatePicker>
            </div>
            <div class="card-body pd-10 pd-sm-20">
              <GmapMap
                :center="{ lat: 47.9138932, lng: 106.8986408 }"
                :zoom="13"
                map-type-id="roadmap"
                labels="off"
                style="width: 100%; height: 65vh"
                ref="map"
              >
                <!-- <GmapCluster> -->
                <GmapInfoWindow
                  :options="infoOptions"
                  :position="infoWindowPos"
                  :opened="infoWinOpen"
                  @closeclick="infoWinOpen = false"
                ></GmapInfoWindow>
                <GmapMarker
                  style="color: green"
                  :icon="`${myResBaseUrl}apps/asset/${m.icon}.png?w=24`"
                  @click="toggleInfoWindow(m, i)"
                  v-for="(m, i) in googleMapMaker"
                  :key="i"
                  :position="m.position"
                  :title="m.title"
                />
              </GmapMap>
            </div>
          </div>
          

        </div>
      </div>
    </div>

    <b-modal v-model="infMdl.modal">
      {{infMdl.title}}
    </b-modal>
  </div>
</template>

<script>

import "element-ui/lib/theme-chalk/index.css";
import { DatePicker } from "element-ui";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";

export default {
  components:{
    DatePicker
  },
  data(){
    return{
      mapDate: null,
      days: [],
      tovchoods: [],
      colors:['green', 'primary', 'orange'],
      assets:{
        cctv: {
          allCount: null,
          count: null,
        },
        penaltyCamera: {
          allCount: null,
          count: null,
        },
        signal: {
          allCount: null,
          count: null,
        },
      },
      googleMapMaker: [],

      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,

      infMdl:{
        modal: false,
        title: ''
      },

      infoOptions: {
        content: "",
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      myResBaseUrl: "https://res.gosmart.mn/",
    }
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted(){
    this.loadAssets();
    this.loadMap();
    this.loadHyazgaarlalt();
    this.loadTovchood();
  },
  methods:{
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleInfoWindow(marker, idx) {
      // console.log('mark', marker);
      // this.toggleBodyClass("addClass", "dynamic-locker");
      // request({
      //   api: { method: "get", url: "Asset/SiteInfo" },
      //   params: {
      //     siteId: marker.deviceId,
      //   },
      //   store: this.$store,
      // }).then((res) => {
      //   this.toggleBodyClass("removeClass", "dynamic-locker");
      //   //this.deviceModal.siteInfo = res.data;
      // });
      this.infMdl.title= marker.title;
      this.infMdl.modal= true;
    },
    loadMap(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "trafficData/AssetDashboardData" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('res', res);
          this.googleMapMaker = res.data.mapData.sites.filter(
              (t) =>
                t.device.location.lat != null && t.device.location.lng != null
            )
            .map((x) => {
              //console.log(`${x.device.type.code}-${x.mapFlag.color}`);
              return {
                id:
                  x.ticket != undefined && x.ticket != null
                    ? x.ticket.id
                    : null,
                title: x.device.deviceName,
                info:
                  x.ticket != undefined && x.ticket != null
                    ? `
                <h4>${moment(x.ticket.createdDate).format(
                  "YYоны MM-р сар DD. HHц:mmм"
                )}</h4>
                <ul class="list-group wd-500">
                  <li class="list-group-item d-flex align-items-center">
                    <div>
                      <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">${
                        x.ticket.task
                      }</h6>
                      <span class="d-block tx-11 text-muted">товч утга</span>
                    </div>
                  </li>
                  <li class="list-group-item active d-flex align-items-center">
                    <div>
                      <h6 class="tx-13 tx-white tx-semibold mg-b-0">${
                        x.device.deviceName
                      }</h6>
                      <span class="d-block tx-11 text-white">төхөөрөмж</span>
                    </div>
                  </li>
                  <li class="list-group-item d-flex align-items-center">
                    <div>
                      <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">${
                        x.ticket.type.name
                      }</h6>
                      <span class="d-block tx-11 text-muted">ангилал</span>
                    </div>
                  </li>
                  
                </ul>
          `
                    : "",
                // <li class="list-group-item d-flex align-items-center">
                //           <a @click="${this.showDetail(x)}">Дэлгэрэнгүй</a>
                //         </li>
                position: {
                  lat: parseFloat(x.device.location.lat),
                  lng: parseFloat(x.device.location.lng),
                },
                icon: `${x.device.deviceType.code}-${x.mapFlag.color}`,
                color: x.mapFlag.color,
                deviceId: x.device.id,
                firstDeviceId: x.firstDeviceId,
                ticketId:
                  x.ticket != undefined && x.ticket != null
                    ? x.ticket.id
                    : null,
              };
            });
        }
      });
    },
    loadAssets() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "trafficData/AssetData" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.assets= res.data.asset;
        }
      });
    },
    
    loadHyazgaarlalt() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/hzbhLimitedPlateNo" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        //console.log(res,' res');
        if (res != false) {
          this.days= res.data.list;
        }
      });
    },
    loadTovchood() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/hzbhEnteredToUbVehicles" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        //console.log(res,' res');
        if (res != false) {
          //console.log(res);
          this.tovchoods= res.data.list1;
        }
      });
    },
  }
}
</script>

<style>

</style>